import Icon from "@vds/icons";
import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown, Menu, Select } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { logout, updateAuth } from "../store/actions/auth";
import { shipmentLogout } from "../store/actions/shipment";

import ThreeDotIcon from "../assets/dashboard.svg";
import VZHeaderlogo from "./../assets/Verizon_RGB.svg";
import SearchIcon from "../assets/search.svg";
import { tsV1LogoutEndPoint } from "../configuration";
import MyProfile from "../pages/MyProfile";
import GlobalSearch from "../pages/GlobalSearch";
import {
  searchRequest,
  isGlobalSearchModelVisible,
} from "../store/actions/globalSearch";

const revokeTokenApi = async (activeSession) => {
  try {
    const formData = new URLSearchParams();
    formData.append("token", activeSession);

    const response = await fetch(tsV1LogoutEndPoint(), {
      method: "POST",
      headers: {
        Authorization: "Bearer " + activeSession,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData.toString(),
    });
    if (!response.ok) {
      throw new Error("Failed to log out");
    }
    return response;
  } catch (error) {
    console.error("Error in invalidating token", error);
    throw new Error("Failed to invalidate token");
  }
};

const NewHeader = ({ left, setLeft, navmenu, link = "" }) => {
  const bearerToken = sessionStorage.getItem("bearer_token");
  const { selectedOrg, user } = useSelector((state) => {
    const accountId = sessionStorage.getItem("accountId");
    let selectedOrg = "";

    if (state?.auth?.user?.billingaccountids) {
      selectedOrg = state?.auth?.user?.billingaccountids[accountId];
    }
    return {
      user: state.auth.user,
      selectedOrg: selectedOrg,
    };
  });
  const dispatch = useDispatch();
  const searchFieldRef = useRef();
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const isGlobalSearchVisible = useSelector(
    (state) => state.globalSearch.isGlobalSearchVisible
  );

  const signout = async () => {
    sessionStorage.clear();
    const response = await revokeTokenApi(bearerToken);
    dispatch(logout());
    localStorage.removeItem("lasActivity");
    dispatch(shipmentLogout());
    navigate("/login");
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const query = searchFieldRef.current.value.trim();
    if (query.length > 0) {
      dispatch(searchRequest(query));
      dispatch(isGlobalSearchModelVisible(true));
    }
    searchFieldRef.current.value = null;
  };

  const showModal = (e) => {
    e.preventDefault();
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleModalGlobalSearchClose = () => {
    dispatch(isGlobalSearchModelVisible(false));
  };

  const handleChange = (val) => {
    sessionStorage.setItem("oldAccountId", user?.accountId);
    sessionStorage.setItem("accountId", val);
    dispatch(
      updateAuth({
        key: "user",
        value: {
          ...user,
          accountId: val,
        },
      })
    );
  };

  return (
    <div
      className="sasp_d-flex sasp_justify-content-start sasp_align-items-center"
      style={{
        padding: "15px 10px",
        background: "#000",
        color: "#fff",
        height: "60px",
        borderBottom: "0.2px solid black",
        position: "relative",
        zIndex: 1000,
      }}
    >
      <div
        className="sasp_d-flex sasp_align-items-center"
        style={{
          gap: "10px",
          minWidth: "200px",
          maxWidth: "200px",
          padding: "10px",
          flexShrink: 0,
        }}
      >
        {navmenu === "show" && (
          <>
            <div
              className="nev-menu"
              onClick={() => setLeft(!left)}
              style={{ flexShrink: 0, padding: "0 0 0 5px" }}
            >
              <img
                alt="threedotimg"
                src={ThreeDotIcon}
                height="20px"
                width="20px"
              />
            </div>
            <Link to="/" style={{ display: "flex", alignItems: "center" }}>
              <img
                alt="profile-user"
                width="125px"
                height="100%"
                style={{
                  objectFit: "contain",
                  maxHeight: "65px",
                }}
                src={VZHeaderlogo}
              />
            </Link>
          </>
        )}

        {navmenu === "hide" && (
          <Link to="" style={{ display: "flex", alignItems: "center" }}>
            <img
              alt="profile-user"
              width="169px"
              height="100%"
              style={{
                objectFit: "contain",
                maxHeight: "65px",
              }}
              src={navmenu === "show" ? "" : VZHeaderlogo}
            />
          </Link>
        )}
      </div>

      {navmenu !== "show" && (
        <h2
          className="font-face-vzw sasp_font-weight-700"
          style={{
            color: "#fff",
            margin: "0 0 0 40px",
            whiteSpace: "nowrap",
          }}
        >
          Asset Tracking Solution
        </h2>
      )}

      {bearerToken && navmenu === "show" && (
        <div
          className="sasp_d-flex sasp_justify-content-between sasp_align-items-center"
          style={{
            flexGrow: 1,
            padding: "0 35px",
            gap: "20px",
          }}
        >
          <div className="d-flex justify-content-start">
            <h2
              className="font-face-vzw sasp_font-weight-700"
              style={{
                color: "#fff",
                margin: 0,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              fontSize:"24px",
              marginTop:"5px"
              }}
            >
              Asset Tracking Solution
            </h2>
            {user?.billingAccountIds &&
              Array.isArray(user?.billingAccountIds) &&
              user?.billingAccountIds?.length > 1 && (
                <Select
                  className="organization-header-select"
                  popupClassName="organization-header-select-option"
                  id="organization-header"
                  value={selectedOrg || ""}
                  onChange={handleChange}
                  options={user?.billingAccountIds || []}
                  required
                />
              )}
          </div>
          <div
            className="sasp_d-flex sasp_justify-content-end sasp_align-items-center"
            style={{ gap: "15px", flexShrink: 0 }}
          >
            <form
              className="search-header"
              onSubmit={handleSearch}
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={SearchIcon}
                alt="search icon"
                style={{
                  position: "absolute",
                  left: "10px",
                  pointerEvents: "none",
                }}
              />
              <input
                type="search"
                placeholder="Search"
                ref={searchFieldRef}
                style={{
                  paddingLeft: "35px",
                }}
              />
            </form>

            <Dropdown
              overlay={
                <Menu className="amt-menubar">
                  <Menu.Item>
                    <ul
                      className="dropdown-menu dropdown-menu-end show"
                      data-bs-popper="static"
                    >
                      <li>
                        <p className="dropdown-header">
                          {user?.firstName} {user?.lastName} - ORG_ADMIN
                          <br />
                          {user?.userName}
                        </p>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={showModal}
                        >
                          Edit profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={() => navigate("/support")}
                        >
                          Support
                        </Link>
                      </li>
                      <li
                        className="dropdown-item"
                        data-turbo="false"
                        onClick={() => signout()}
                      >
                        Sign out
                      </li>
                    </ul>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <a
                className="btn btn-link text-secondary"
                role="button"
                data-bs-toggle="dropdown"
                onClick={(e) => e.preventDefault()}
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <Icon
                  className="my-account"
                  name="my-account"
                  color="#fff"
                  size="large"
                />
                <DownOutlined style={{ color: "#fff" }} />
              </a>
            </Dropdown>
          </div>
        </div>
      )}

      {link === "" ? null : (
        <div className="signin-menu-div user-menu ms-lg-auto d-flex align-self-center align-items-center">
          <Link to="/login" className="signin-menu">
            Login
          </Link>
        </div>
      )}

      {isModalVisible && (
        <MyProfile visible={isModalVisible} onClose={handleModalClose} />
      )}
      {isGlobalSearchVisible && (
        <GlobalSearch
          visible={isGlobalSearchVisible}
          onClose={handleModalGlobalSearchClose}
        />
      )}
    </div>
  );
};

export default NewHeader;
